import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, Typography } from '@mui/material';
import PlanHistory from './PlanHistory';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner'
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const PlansLookupQuery = graphql`
query PlansLookupQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    parentId
    accountType
    accountStatus
    accountNum
    accountName
    feePlanId
    feePlanTByFeePlanId {
      feePlanName
    }
    abSubscriptionTsByAccountId {
      totalCount
    }
  }
  allFeePlanTs(orderBy: CREATED_ASC) {
    nodes {
      feePlanId
      feePlanDescription
      feeAnnual
      feeMonthly
      feeSelfPercentage
      feeCustPercentage
      feePlanName
      selfService
    }
  }
}
`;


const styleSheet = theme => ({
  paper: {
    marginTop: 16,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    color: theme.palette.text.secondary,
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 150,
    width: 180
  },
  dbTileSelected: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 150,
    width: 180,
    backgroundColor: '#D3D3D3'
  }
});

class Plans extends Component {

  state = {
    feePlanName: null,
    showPlanChangeDialog: false,
    showSpinner: false,
    fetchCount: 0
  };

  showSpinner() {
    return this.state.showSpinner;
  }

  disableSave(props) {
    if (this.state.feePlanName === null) {
      return true;
    }

    //console.log(this.state.feePlanName + '/' + props.accountTByAccountId.feePlanTByFeePlanId.feePlanName);

    if (this.state.feePlanName === props.accountTByAccountId.feePlanTByFeePlanId.feePlanName) {
      return true
    }
    return false;
  }

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  selectFeePlan(plan) {
    if (plan.selfService === 0) {
      return;
    }
    this.setState({feePlanName: plan.feePlanName})
  }

  render() {
    const classes = this.props.classes;
    const { logError } = this.props.auth;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={PlansLookupQuery}
        variables={{accountId: this.props.accountId, forceUpdate: this.state.fetchCount}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            let confirmationStatement = '';
            if (this.state.feePlanName) {
              confirmationStatement = 'You are changing your plan!!!';
              let i = 0;
              for (i = 0; i < props.allFeePlanTs.nodes.length; i++) {
                let plan = props.allFeePlanTs.nodes[i];
                if (plan.feePlanName === this.state.feePlanName) {
                  confirmationStatement = 'You are changing your plan to ' + plan.feePlanName + ' plan.';
                  confirmationStatement = confirmationStatement + ' You will be charged ' + Number(plan.feeMonthly).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ' monthly.'
                  confirmationStatement = confirmationStatement + ' The amount will be prorated for this month based on the number of days left.  Proceed?'
                  break;
                }
              }
            }

            return (
              <div>
                <Typography variant="h6">AppBind Plans</Typography>
                <Typography variant="body2">
                  AppBind supports several types of plans for your business needs
                </Typography>
        
                <Grid container spacing={2} justifyContent="flex-start" style={{ marginTop: 8 }}>
                {props.allFeePlanTs.nodes.map(n => {
                    return (
                      <Grid item>
                        <Grid container spacing={2}>
                          <Grid item>
                            <Paper className={(this.getValueForRender(this.state.feePlanName, props.accountTByAccountId.feePlanTByFeePlanId.feePlanName, "Default") === n.feePlanName ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.selectFeePlan(n); }}>
                              <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                <Grid item>
                                  <Typography variant="h6">
                                    {n.feePlanName}
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography variant="body2" style={{ marginTop: 2 }}>
                                    {n.feePlanDescription}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        </Grid>
                      </Grid>                              
                    );
                  })}
                  <Grid item xs={12}>
                      <Grid container spacing={3} direction="row" justifyContent="flex-start">
                        <Grid item xs={1}>
                          { !this.showSpinner() &&
                            <Button disabled={this.disableSave(props)} variant="contained" color="primary"  style={AppBindStyles.bottomButton}
                              onClick={() => {this.setState({showPlanChangeDialog:true}); }}>
                              Save
                            </Button>
                          }
                          {this.showSpinner() &&
                          <Button color="primary" variant="contained" style={AppBindStyles.bottomButton}>
                            <SavingSpinner/>
                          </Button>
                          }
                        </Grid>
                      </Grid>
                  </Grid>
                  <ConfirmationDialog
                          open={this.state.showPlanChangeDialog}
                          onClose={() => { this.setState({showPlanChangeDialog:false});}}
                          onConfirm={() => { this._updatePlan(props); }}
                          onCancel={() => { }}
                          title="Change plans?"
                          cancelBtn="Cancel"
                          okBtn="Ok"
                        >
                          {confirmationStatement}
                      </ConfirmationDialog>
                </Grid>
                {props.accountTByAccountId.abSubscriptionTsByAccountId.totalCount > 0 &&
                <PlanHistory forceFetch={this.state.forceUpdate} 
                             accountId={this.props.accountId}
                             auth={this.props.auth}>
                </PlanHistory>
                }
              </div>    
            );
          }
          return <div><LoadingSpinner/></div>
        }}
      />
    );




  }


  _updatePlan = (props) => {

    const { callPartnerApi } = this.props.auth;

    this.setState({showSpinner: true});

    let feePlanId = null;
    //find the fee plan id 
    for (let i = 0; i < props.allFeePlanTs.nodes.length; i++) {
      let feePlan = props.allFeePlanTs.nodes[i];
      if (feePlan.feePlanName === this.state.feePlanName) {
        feePlanId = feePlan.feePlanId;
        break;
      }
    }


    let aPjwt = abEnvironment.getPjwt();
 
    let payload = {
      operation: "updateAppBindPlan",
      params: {
        pJwt: aPjwt,
        accountId: this.props.accountId,
        feePlanId: feePlanId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      let fetch = this.state.fetchCount;
      fetch++;

      this.setState({ fetchCount: fetch, showSpinner: false });


    })
    .catch(error => {

      this.setState({ showSpinner: false });
    });
 
  }
}

export default withStyles(styleSheet)(Plans);